export default __webpack_public_path__ + "static/media/mf.98c86040.jpg";